/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ProcessInstrumentLinkResultEventsRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/ProcessInstrumentLinkResultEvents.pb'
import {ProcessInstrumentLinkResultEventsResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/ProcessInstrumentLinkResultEvents.pb'


export const processInstrumentLinkResultEvents = (request: ProcessInstrumentLinkResultEventsRequest, options?: CashRequestOptions) => post<ProcessInstrumentLinkResultEventsRequest, ProcessInstrumentLinkResultEventsResponse>("/2.0/cash/process-instrument-link-result-events", request, {...options, rejectOnError: true })